import { Filters } from 'react-table';

export const mapFiltersToSpecification = (filters: Filters<any>): string => {
    // Use map to transform each object into the desired format
    const formattedItems = filters.map((item) => {
        const capitalizedId = item.id.charAt(0).toUpperCase() + item.id.slice(1);
        return `${capitalizedId}Specification:${item.value}`;
    });

    // Use join to concatenate the formatted items with commas
    return formattedItems.join(',');
};

export const mapSearchParamToSpecification = (searchParam: string, cols: Array<string>): string => {
    const filters = cols.map((col) => ({ id: col, value: searchParam }));

    return mapFiltersToSpecification(filters);
};
